import { formatCPF } from "@brazilian-utils/brazilian-utils";
import { Modal } from "antd";
import { ProcuracaoDetalhe } from "core/features/assembleia/typings/procuracao";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";
import moment from "moment";
import React from "react";

interface ModalProcuracaoProps {
  visible: boolean;
  onClose: () => any;
  procuracao: ProcuracaoDetalhe;
}
function ModalProcuracao({
  visible,
  onClose,
  procuracao,
}: ModalProcuracaoProps) {
  const html = getHtml(procuracao);

  return (
    <Modal
      destroyOnClose
      width="800px"
      closable
      centered
      footer={null}
      bodyStyle={{
        height: "29.7cm",
        width: "21cm",
      }}
      visible={visible}
      onCancel={onClose}
    >
      <div
        id="div-modal-procuracao"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Modal>
  );
}

const getHtml = (procuracao: ProcuracaoDetalhe) => {
  return `
    <div class="container-procuracao-html">
      <h1 class="titulo-procuracao-html">
        PROCURAÇÃO
      </h1>
      <p class="corpo-procuracao-html">
        Eu, ${procuracao.solicitante?.nome}, portador do CPF ${formatCPF(
    procuracao.solicitante?.documento
  )}, proprietário
        da ${formatBlocoQuadra(
          procuracao.unidades[0]?.numero,
          procuracao.unidades[0]?.blocoQuadra
        )}, autorizo para
        realizar os procedimentos relacionados às assembleias condominiais ${
          procuracao.solicitante?.nome
        }, portador do CPF ${formatCPF(procuracao.representante?.nome)}.
      </p>

      <p class="data-procuracao-html">
        Cuiabá, ${moment().format("DD [de] MMMM [de] YYYY")}
      </p>

      <div class="assinatura-procuracao-html">
        <img class="imagem-assinatura-procuracao-html" src=${
          procuracao.assinaturaArquivo?.referencia
        } />
        <div class="linha-assinatura-procuracao-html" />
        <p class="descricao-assinatura-procuracao-html">Assinatura</p>
      </div>
    </div>
  `;
};

export default ModalProcuracao;
